export enum MemberEnum {
  Member = 'Member'
}

export enum MemberEnumApi {
  member = 'members/',
  memberServices = 'memberServices/'
}

export enum MemberServiceType {
  ServiceProvider = 'Service Provider',
  ServiceReceiver = 'Service Receiver'
}

export enum MemberTypes {
  Normal = 'normal',
  VIP = 'vip'
}

export enum MemberStatus {
  Approved = 'approved',
  Terminate = 'terminate',
  Pending = 'pending',
  Die = 'die',
  Resigned = 'resigned',
}

export enum MemberDurationStatus {
  Normal = 'normal',
  moreThenOneMonths = 'moreThenOneMonths',
  moreThenThreeMonths = 'moreThenThreeMonths',
  moreThenThreeYears = 'moreThenThreeYears'
}

